import { mapState, mapMutations } from 'vuex'
import api from '../service/services'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'
import swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import moment from 'moment'

export default {
  data() {
    return {
      data: [],
      isLoading: false,
      data_bill: [],
      data_images: [],
      count_images: 0,
      total_images: 0,
      zipfile: [],
      error_massage: '',
      perload: 0,
      selected: false,
      checkbox_data: [],
      isDownload: 0,
      current_page: 1,
      items_perpage: 20,
      result_count: 0,
      getData: false,
      paginateData: [],
      files: [],
      guide_name: [],
      photograph_name: [],
      emails: [],
      timeShow: 0,
    }
  },
  computed: {
    ...mapState(['user', 'url']),
    ...mapMutations(['checkLogin']),
  },
  components: {
    Loading,
  },
  methods: {
    getBill(key) {
      var obj = {
        bill_key: key,
      }
      api.AXbill(
        this.url,
        obj,
        (result) => {
          if (result.status === 1) {
            this.data = result.data
            this.data_bill = result.data.bill
            this.emails.push({ email: '' })
            this.checkMinius()
          } else {
            // this.isLoading = false
            this.isDownload = 1
            this.error_massage = result.data
            alert('error ' + JSON.stringify(result))
          }
        },
        (error) => {
          this.isLoading = false
          alert(JSON.stringify(error))
        },
      )
    },
    checkMinius() {
      const dateStart = new Date(this.data_bill.bill_date)
      const dateEnd = new Date()
      const differenceMs = dateEnd - dateStart
      this.timeShow = Math.round(differenceMs / (1000 * 60 * 60))
    },
    dateFormat(date) {
      return moment(date).format('DD/MM/YYYY')
    },
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(email)
    },
    addEmail() {
      if (this.emails.length > 0) {
        var data = []
        this.emails.forEach((v) => {
          if (v.email != '') {
            data.push({ email: v.email })
          }
        })
        swal
          .fire({
            title: 'Confirm Email',
            text: 'This Your ' + data.length + ' Email',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
          })
          .then((res) => {
            if (res.value) {
              api.AXaddemail(
                this.url,
                {
                  id: this.data_bill.bill_id,
                  data: data,
                },
                (result) => {
                  if (result.status === 1) {
                    swal.fire('Good Job!', 'Send email success', 'success')
                    this.sendMail()
                  } else {
                    swal.fire('Error 500', 'Email is incorrect!', 'error')
                  }
                },
                (error) => {
                  alert(JSON.stringify(error))
                },
              )
            }
          })
      } else {
        swal.fire('Add Email', 'Email is incorrect!', 'warning')
      }
    },
    sendMail() {
      api.AXsendemail(
        this.url,
        {
          bill_id: this.data_bill.bill_id,
        },
        (result) => {
          if (result.status === 1) {
            this.emails = []
            this.getBill(this.$route.params.key)
          } else {
            swal.fire('Error 500', 'Email is incorrect!', 'error')
          }
        },
        (error) => {
          alert(JSON.stringify(error))
        },
      )
    },
  },
  mounted() {
    this.getBill(this.$route.params.key)
  },
}



// WEBPACK FOOTER //
// ./src/js/addmail.js